/**
 * Class defining promotions information data descriptors.
 *
 * @class PromotionsDataDescriptors
 * @name descriptor
 * @memberof Mojito.Services.Promotions
 */
export default class PromotionsDataDescriptors {
    /**
     * Factory method for creating a promotions data descriptor.
     *
     * @param {Array<string>} channels - Promotions channels to subscribe.
     *
     * @returns {{dataType: string, channels: string}} Promotions data descriptor.
     *
     * @function Mojito.Services.Promotions.descriptor#createPromotionsDescriptor
     * @static
     */
    static createPromotionsDescriptor(channels) {
        return {
            dataType: PromotionsDataDescriptors.DATA_TYPES.PROMOTIONS,
            channels,
        };
    }

    /**
     * Factory method for creating a promotion container data descriptor.
     *
     * @param {Array<string>} channels - Promotion container channels to subscribe (e.g. `desktop`, `desktop_auth`).
     * @param {string} containerId - Promotion container id to subscribe to.
     *
     * @returns {{dataType: string, channels: Array<string>, containerId: string}} Promotion container data descriptor.
     *
     * @function Mojito.Services.Promotions.descriptor#createContainersDescriptor
     * @static
     */
    static createContainersDescriptor(channels, containerId) {
        return {
            dataType: PromotionsDataDescriptors.DATA_TYPES.CMS_CONTAINER,
            channels,
            containerId,
        };
    }
}

/**
 * Promotions unique data descriptor types.
 *
 * @typedef DATA_TYPES
 * @property {string} PROMOTIONS - Descriptor type for the promotions.
 *
 * @memberof Mojito.Services.Promotions.descriptor
 */
PromotionsDataDescriptors.DATA_TYPES = {
    PROMOTIONS: 'promotions',
    CMS_CONTAINER: 'cmsContainer',
};
